module.exports = __webpack_public_path__ + "img/pitch-deck.8de0526a.svg";